import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import TableauEmbedded from './TableauEmbedded';

interface DashboardProps {
  isCollapsed?: boolean;
}

const Dashboard: React.FC<DashboardProps> = ({ isCollapsed }) => {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <TableauEmbedded isCollapsed={isCollapsed ?? false} />
      </MainLayout>
    </div>
  );
};

export default Dashboard;